import { Injectable } from '@angular/core';
import { ErrorResponse } from '../../models/error-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DialogService } from './dialog.service';
import { NavigationService } from './navigation.service';
import { AuthService } from './auth.service';
import * as moment from 'moment';

@Injectable()
export class UtilitiesService {

  constructor(
    private _dialogService: DialogService,
    private _navigationService: NavigationService,
    private _httpClient: HttpClient) {

    this.httpConfig =  {
      withCredentials: true
    };

    const regExYearShort = '[0-9]{2}';
    const regExYearLong = '((19|20|21)' + regExYearShort + ')';
    const regExMonth = '(0[1-9]|1[0-2])';
    const regExDayPersonnummer = '(0[1-9]|((1|2)[0-9])|3[0-1])';
    const regExDaySamordningsnummer = '(6[1-9]|((7|8)[0-9])|9[0-1])';
    const regExDayPersonnummerWithSamordningsnummer = '(' + regExDayPersonnummer + '|' + regExDaySamordningsnummer + ')';
    const regExSuffix = '[0-9]{4}';

    // SSYYMMDD-NNNN
    this.personnummerReqEx = '(' + regExYearLong + regExMonth + regExDayPersonnummer + '-' + regExSuffix + ')';
    this.samordningsnummerReqEx = '(' + regExYearLong + regExMonth + regExDaySamordningsnummer + '-' + regExSuffix + ')';
    this.personnummerSamordningsnummerReqEx = '(' + regExYearLong + regExMonth + regExDayPersonnummerWithSamordningsnummer
    + '-' + regExSuffix + ')';

    this.passwordRegEx = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^\\da-zA-ZäöåüÅÖÄÜ]).{8,}$';
  }

  public httpConfig: object;
  public personnummerReqEx: string;
  public samordningsnummerReqEx: string;
  public personnummerSamordningsnummerReqEx: string;
  public passwordRegEx: string;
  private _majorActionsActive: string[] = [];
  private _minorActionsActive: string[] = [];
  private _preChoosenOrganisationUnit: string;

  handleErrors(err: object) {
    let errors: ErrorResponse[];
    if (err['status'] && err['status'] !== 401 && err['status'] !== 0) {
      if (err['status'] === 404) {
        errors.push(new ErrorResponse(404, err['message']));
      } else if (err['error']) {
        errors = err['error']['response'];
      } else {
        errors = err['response'];
      }
      this.delteActiveActions();
      this._dialogService.showErrorDialog(errors);
    } else {
      this.delteActiveActions();
      this._navigationService.navigateTo('login');
    }
  }

  getData(data: object) {
    if (data['body']) {
      return data['body']['response'];
    } else {
      return data['response'];
    }
  }

  getAPIUrl() {
    // return 'http://' + window.location.hostname + ':' + environment.apiPort + '/api/';
    return environment.serviceBaseUrl;
  }

  checkPersonnumber(personnumber: string) {
    return this._httpClient.get(this.getAPIUrl() + 'Check/Personnummer?personnummer=' + personnumber, this.httpConfig);
  }

  addMajorAction(actionName: string) {
    if (this.isSomeActionActive()) {
      const index = this._majorActionsActive.indexOf(actionName);
      if (index === -1) {
        this._majorActionsActive.push(actionName);
      }
    } else {
      this._majorActionsActive.push(actionName);
    }
  }

  addMinorAction(actionName: string) {
    if (this.isSomeActionActive()) {
      const index = this._minorActionsActive.indexOf(actionName);
      if (index === -1) {
        this._minorActionsActive.push(actionName);
      }
    } else {
      this._minorActionsActive.push(actionName);
    }
  }

  removeAction(actionName: string) {
    if (this.isSomeActionActive()) {
      let index = this._majorActionsActive.indexOf(actionName);
      if (index > -1) {
        this._majorActionsActive.splice(index, 1);
      }

      index = this._minorActionsActive.indexOf(actionName);
      if (index > -1) {
        this._minorActionsActive.splice(index, 1);
      }
    }
  }

  removeInitAction(waitSek: number) {
    setTimeout(() => {
      this.removeAction('Init');
    },
    waitSek * 1000);
  }

  delteActiveActions() {
    this._minorActionsActive = [];
    this._majorActionsActive = [];
  }

  isSomeActionActive() {
    return ((this._majorActionsActive !== [] && this._majorActionsActive.length > 0) ||
            (this._minorActionsActive !== [] && this._minorActionsActive.length > 0));
  }

  isSomeMajorActionActive() {
    return (this._majorActionsActive !== [] && this._majorActionsActive.length > 0);
  }

  isSomeMinorActionActive() {
    return (this._minorActionsActive !== [] && this._minorActionsActive.length > 0);
  }

  isActionActive(actionName: string) {
    if (this.isSomeActionActive()) {
      let index = this._majorActionsActive.indexOf(actionName);
      if (index > -1) {
        return true;
      }

      index = this._minorActionsActive.indexOf(actionName);
      if (index > -1) {
        return true;
      }
    }
    return false;
  }

  fixUTCUnixtimestamp(inMoment: moment.Moment) {
    if (inMoment) {
      const fixedUtcDate = moment.utc([inMoment.year(),
                                      inMoment.month(),
                                      inMoment.date(),
                                      inMoment.hour(),
                                      inMoment.minute(), 0, 0]);
      return fixedUtcDate.unix();
    }

    return 0;
  }

  setPreChoosenOrganisation(preChoosenOrganisationId: string) {
    this._preChoosenOrganisationUnit = preChoosenOrganisationId;
  }

  deletePreChoosenOrganisation() {
    this._preChoosenOrganisationUnit = null;
  }

  getPreChoosenOrganisation() {
    return this._preChoosenOrganisationUnit;
  }

  wasOrgPreChoosen() {
    return this._preChoosenOrganisationUnit && this._preChoosenOrganisationUnit !== null && this._preChoosenOrganisationUnit !== '';
  }
}
